import clsx from 'clsx';
import type React from 'react';

export const BlurryCircle = (props: { children: React.ReactNode; blurry?: boolean }) => {
  const blurry = props.blurry ?? true;

  return (
    <div
      data-slot="blurry-circle"
      className={clsx(
        'absolute top-0 left-1/2 z-10 grid aspect-square size-16 -translate-1/2 place-items-center rounded-full sm:scale-110 xl:scale-125',
        blurry && 'bg-white/10 backdrop-blur-lg',
      )}
    >
      {props.children}
    </div>
  );
};

export const BlurryCircleIcon = (props: {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  color?: 'info' | 'success' | 'error';
}) => {
  const color = props.color ?? 'info';

  return (
    <div
      className={clsx(
        'grid size-8.5 place-items-center rounded-full text-white',
        props.className,
        {
          info: 'bg-[#18A0FB]',
          success: 'bg-[#56BA82]',
          error: 'bg-[#FD647C]',
        }[color],
      )}
      style={props.style}
    >
      {props.children}
    </div>
  );
};
